import React, {useEffect, useState} from 'react';
import {MenuItem} from '../../@types/menu';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import If from '../If';
import {faAngleDown, faAngleUp} from '@fortawesome/free-solid-svg-icons';
import {Link, useLocation} from 'react-router-dom';
import classNames from 'classnames';
import {useInformesEvento} from '../../../app/shared/contexts/InformesEventoContext';

interface Props {
  item: MenuItem,
}

export default function MenuItemComponent({item}: Props) {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const {total: totalInformes} = useInformesEvento();
  const badgeCount = item.badgeSource === 'informes' ? totalInformes : 0;

  useEffect(() => {
    if (item.items && item.items.length > 0) {
      if (location.pathname === '/em-construcao') {
        setOpen(false);
        return;
      }
      setOpen(item.items.filter(f => f.url &&
        (f.url === location.pathname ||
          (!!f.majorPath && location.pathname.indexOf(f.majorPath) >= 0)
        )).length > 0);
    }
  }, [location]);

  const isActive = () => {
    if (location.pathname === '/em-construcao') {
      return false;
    }
    return location.pathname === item.url || (!!item.majorPath && location.pathname.indexOf(item.majorPath) >= 0);
  }

  const itemComponent = () => {
    return (
      <span>
        <If condition={!!item.icon}>
            <span>
              {item.icon && <FontAwesomeIcon icon={item.icon}/>}
            </span>
        </If>
        {
          item.url &&
          <Link to={item.url}>
            <label className={classNames({'app-active': isActive()})}>{item.label}</label>
          </Link>
        }
        {
          !item.url &&
          <label className={classNames({'app-active': isActive(), 'app-open': open})}>{item.label}</label>
        }
        <If condition={badgeCount > 0}>
          <span className="app-menu-badge">{badgeCount}</span>
        </If>
      </span>
    );
  }
  if (item.items && item.items.length > 0) {
    return (
      <div className="app-menu-item">
        <div style={{width: '100%'}}>
          <div className="app-submenu-title" onClick={() => setOpen(!open)}>
            {itemComponent()}
            <FontAwesomeIcon icon={open ? faAngleUp : faAngleDown}/>
          </div>
          <If condition={open}>
            <div className="app-submenu">
              {item.items.map(m => <MenuItemComponent key={m.id} item={m}/>)}
            </div>
          </If>
        </div>
      </div>
    );
  }
  return (
    <div className="app-menu-item">
      {itemComponent()}
    </div>
  );
}
